import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DocumentService } from 'src/app/services/document.service';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { MainDialogComponent } from './main dialog/main-dialog.component';

@Component({
  selector: 'patient-location-date-comp',
  template: `
  <button class="float-right mb-2" mat-button (click)="onX()">✖</button>
  <br>
  <br>
    <agm-map
      [zoom]="zoom"
      [latitude]="lat"
      [longitude]="lng"
      style="height: 520px; margin-top: 30px;"
    >
      <agm-marker
        *ngFor="let marker of markers"
        [latitude]="marker.lat"
        [longitude]="marker.lng"
      >
        <agm-info-window>
          <a style="color:#000000!important" (click)="cancel(marker.id)">
            {{marker.title}}
          </a>
        </agm-info-window>
      </agm-marker>
    </agm-map>
  `,
})
export class UsecaseLocationComponent {
  lat: any;
  lng: any;
  radius: any;
  inputData: any=[];
  zoom: number;
  markers: any = [];
  center: any;
  public viewDocument:any;

  constructor(
    private dialogRef: MatDialogRef<MainDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private req: HttpRequestsService<any>,
    private doc:DocumentService,
    private router: Router
  ) {
    this.inputData = this.data.dialogConfig.data.data;
    this.inputData.forEach(element => {
      this.markers.push({
        lat:element.latitude,
        lng:element.longitude,
        title:element.title,
        id:element.id
      })
    });
    this.lat = 50.8503;
    this.lng = 4.3517;
    this.zoom = 3;
  }

  ngOnInit() {  }

  cancel(id) {
    this.req.getDocument(id).subscribe(
      (res) => {
        this.viewDocument = res[0];
      },
      (error) => console.log(error),
      () =>{
        (this.doc.data = this.viewDocument)
        this.router.navigate(['ViewDocument']);
      } 
    );
    this.dialogRef.close();
  }

  onX(): void {
    this.dialogRef.close();
  }
}
